import React from 'react';
import { COLORS } from '../utils/gameLogic';
import './Ball.css';

export default function Ball({ color, isTop, isSelected }) {
  const c = COLORS[color] || COLORS.pink;
  return (
    <div
      className={`ball ${isTop ? 'top-ball' : ''} ${isSelected ? 'selected-ball' : ''}`}
      style={{
        '--ball-color': c.bg,
        '--ball-glow': c.glow,
        '--ball-light': c.light,
        '--ball-dark': c.dark,
      }}
    >
      <div className="ball-shine" />
      <div className="ball-shine2" />
    </div>
  );
}
